import { render, staticRenderFns } from "./PaymentOfflineInputs.vue?vue&type=template&id=671dd3d9&"
import script from "./PaymentOfflineInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentOfflineInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports